
import PropTypes from 'prop-types';

import { TableRow, TableCell, Button } from "@mui/material";
import { ConfirmDialog } from '../../../../components/custom-dialog/index.js';
import { useBoolean } from '../../../../hooks/use-boolean.js';


export default function CourseSummaryReportTableRow({row, selected, onSelected, onDeleteRow, onCancelledRow, onEditRow, onViewRow, onCompleted, onRevert}){
  const { _id, totalClasses, totalConfirmedClasses, totalDraftClasses, totalCancelledClasses, totalCompletedClasses, countConfirmedTrainee, countDraftTrainee } =row;


    const confirm = useBoolean();
    const cancel = useBoolean();
    const completed = useBoolean();
    const revertBack = useBoolean();

 return (
    <>
    <TableRow hover selected={selected}>
             <TableCell>{_id}</TableCell>
            <TableCell sx={{whiteSpace: 'nowrap'}}>{totalConfirmedClasses}</TableCell>
            <TableCell sx={{whiteSpace: 'nowrap'}}>{totalCompletedClasses}</TableCell>
            <TableCell sx={{whiteSpace: 'nowrap'}}>{totalDraftClasses}</TableCell>
            <TableCell sx={{whiteSpace: 'nowrap'}}>{totalClasses}</TableCell>
            <TableCell sx={{whiteSpace: 'nowrap'}}>{countConfirmedTrainee || countDraftTrainee}</TableCell>
    </TableRow>
         


    <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content={`Are you sure want to delete ${_id}?`}
        action={
          <Button variant="contained" color="error" onClick={() => {
            onDeleteRow();
            confirm.onFalse();
          }}>
            Delete
          </Button>
        }
      />

<ConfirmDialog
        open={cancel.value}
        onClose={cancel.onFalse}
        title="Cancel"
        content={`Are you sure want to cancel ${_id}?`}
        action={
          <Button variant="contained" color="error" onClick={onCancelledRow}>
            Cancel
          </Button>
        }
      />

      <ConfirmDialog
        open={completed.value}
        onClose={completed.onFalse}
        title="Completed"
        content={`Are you sure want to update ${_id} status to completed?`}
        action={
          <Button variant="contained" color="success" onClick={() => {
            onCompleted();
            completed.onFalse();
          }}>
            Yes
          </Button>
        }
      />

<ConfirmDialog
        open={revertBack.value}
        onClose={revertBack.onFalse}
        title="Revert Status"
        content={`Are you sure want to revert the  status to confirmed?`}
        action={
          <Button variant="contained" color="success" onClick={() => {
            onRevert();
            revertBack.onFalse();
          }}>
            Yes
          </Button>
        }
      />

</>
 )

}

CourseSummaryReportTableRow.propTypes = {
    onViewRow: PropTypes.func,
    onEditRow: PropTypes.func
  };
  
